import {createReducers, createActions, request} from '../../../utils/';
import {combineReducers} from 'redux';
import Urls from '../../../../config/index';

const {DeviceIndexUrl} = Urls;

const path = name => `app/pages/deviceIndex/${name}`;


const models = {

    list: {
        data: [],
        handlers: {
            get(state, action) {
                return action.payload;
            },
            add(state, action) {
                return [...action.payload, ...state];
            },
            del(state, action) {
                return state.filter(item => item._id !== action.payload);
            },
            update(state, action) {
                return state.map(item => (item._id === action.payload._id ? action.payload : item));
            },
        },
    },

    // 地区信息
    areaData: {
        data: [],
        handlers: {
            areaList(state, action) {
                return action.payload;
            },
        },
    },
    // 标签信息
    deviceTagData: {
        data: [],
        handlers: {
            deviceTagList(state, action) {
                return action.payload;
            },
        },
    },
    // 多选删除
    deleteMultiData: {
        data: [],
        handlers: {
            deleteMulti(state, action) {
                return action.payload;
            },
        },
    },

    transferData: {
        data: {
            selectedRowKeys: [],
        },
        handlers: {
            getTransferData(state, action) {
                return {...state, ...action.payload};
            },
        },
    },
    // 分页
    pagination: {
        data: {
            current: 1,
            total: 0,
            pageSize: 10,
        },
        handlers: {
            changePagination(state, action) {
                return {
                    ...state,
                    ...action.payload,
                };
            },
        },
    },
    // 查询数据
    searchValues: {
        data: {},
        handlers: {
            changeSearchValues(state, action) {
                return action.payload;
            },
        },
    },
    // 状态
    uiStatus: {
        data: {
            isLoading: false,
            isUpdateShow: false,
            isSendCommend: false,
        },
        handlers: {
            changeUiStatus(state, action) {
                return {
                    ...state,
                    ...action.payload,
                };
            },
        },
    },
    // 当前选择数据的id
    currentSelectId: {
        data: '',
        handlers: {
            changeCurrentSelectId(state, action) {
                return action.payload;
            },
        },
    },

};

export const actions = createActions(models, path);

export default combineReducers(createReducers(models, path));

/**
 * 列表请求参数
 *
 * @param getState
 * @returns {{pageSize: *, page: *}}
 */
const formatGetParams = getState => {
    const state = getState().deviceIndex;
    const searchValue = state.searchValues || {};

    const params = {
        querys: {...searchValue},
        pagination: {
            current: state.pagination.current,
            pageSize: state.pagination.pageSize,
        }
    };
    return params;
};

/**
 * 列表
 *
 * @returns {function(*, *=): Promise<void>}
 */
export const asyncList = () => {
    return async (dispatch, getState) => {
        try {
            dispatch(
                actions.changeUiStatus({
                    isLoading: true,
                }),
            );
            let result = await request(DeviceIndexUrl.list, 'POST', formatGetParams(getState));
            let {list, total} = result;
            list = list.map(item => {
                item.key = item.id;
                return item;
            });
            dispatch(actions.get(list));
            dispatch(actions.changePagination({total: total}));
        } catch (e) {
            throw e;
        } finally {
            dispatch(
                actions.changeUiStatus({
                    isLoading: false,
                }),
            );
        }
    };
};

/**
 * 生成索引
 *
 * @param content
 * @returns {function(*, *): Promise<void>}
 */
export const asyncAdd = (content) => {
    return async (dispatch, getState) => {
        try {
            dispatch(actions.changeUiStatus({isLoading: true}));

            await request(DeviceIndexUrl.generate, 'POST', content);

        } catch (e) {
            throw e;
        } finally {
            dispatch(actions.changeUiStatus({isLoading: false}));
        }
    };
};

/**
 * 重新生成索引
 *
 * @param content
 * @returns {function(*, *): Promise<void>}
 */
export const asyncUpdate = (content) => {
    return async (dispatch, getState) => {
        try {
            dispatch(actions.changeUiStatus({isLoading: true}));
            await request(DeviceIndexUrl.reGenerate, 'POST', content);
        } catch (e) {
            throw e;
        } finally {
            dispatch(actions.changeUiStatus({isLoading: false}));
        }
    };
};

/**
 * 地区信息
 *
 * @returns {function(*, *): Promise<void>}
 */
export const asyncAreaList = () => {
    return async (dispatch, getState) => {
        try {
            dispatch(actions.changeUiStatus({isLoading: true,}),);
            const result = await request(DeviceIndexUrl.listAreas, 'GET');
            dispatch(actions.areaList(result));
        } catch (e) {
            throw e;
        } finally {
            dispatch(actions.changeUiStatus({isLoading: false,}),);
        }
    };
}

/**
 * 标签信息
 *
 * @returns {function(*, *): Promise<void>}
 */
export const asyncDeviceTagList = () => {
    return async (dispatch, getState) => {
        try {
            dispatch(actions.changeUiStatus({isLoading: true,}),);
            const result = await request(DeviceIndexUrl.listDeviceTags, 'GET');
            dispatch(actions.deviceTagList(result));
        } catch (e) {
            throw e;
        } finally {
            dispatch(actions.changeUiStatus({isLoading: false,}),);
        }
    };
}

/**
 * 删除
 *
 * @param devicePrefixName
 * @returns {function(*, *): Promise<void>}
 */
export const asyncDelete = devicePrefixName => {
    return async (dispatch, getState) => {
        try {
            dispatch(actions.changeUiStatus({isLoading: true}));
            await request(DeviceIndexUrl.remove + devicePrefixName, 'GET', {});
        } catch (e) {
            throw e;
        } finally {
            dispatch(actions.changeUiStatus({isLoading: false}));
        }
    };
};

/**
 * 删除索引
 *
 * @param devicePrefixName
 * @returns {function(*, *): Promise<void>}
 */
export const asyncDeleteDeviceIndex = devicePrefixName => {
    return async (dispatch, getState) => {
        try {
            dispatch(actions.changeUiStatus({isLoading: true}));
            await request(DeviceIndexUrl.removeDeviceIndex + devicePrefixName, 'GET', {});
        } catch (e) {
            throw e;
        } finally {
            dispatch(actions.changeUiStatus({isLoading: false}));
        }
    };
};


/**
 * 校验
 *
 * @param devicePrefixName
 * @returns {function(*, *): Promise<void>}
 */
export const asyncCheck = devicePrefixName => {
    return async (dispatch, getState) => {
        try {
            dispatch(actions.changeUiStatus({isLoading: true}));
            const data = await request(DeviceIndexUrl.check + devicePrefixName, 'GET', {});
            return data;
        } catch (e) {
            throw e;
        } finally {
            dispatch(actions.changeUiStatus({isLoading: false}));
        }
    };
};

/**
 * 停止
 *
 * @param devicePrefixName
 * @returns {function(*, *): Promise<void>}
 */
export const asyncStop = devicePrefixName => {
    return async (dispatch, getState) => {
        try {
            dispatch(actions.changeUiStatus({isLoading: true}));
            const data = await request(DeviceIndexUrl.stop + devicePrefixName, 'GET', {});
            return data;
        } catch (e) {
            throw e;
        } finally {
            dispatch(actions.changeUiStatus({isLoading: false}));
        }
    };
};




// WEBPACK FOOTER //
// ./pages/assist/deviceIndex/reducers.js